import { Component } from '@angular/core';

@Component({
  selector: 'app-environment-release-package',
  templateUrl: './environment-release-package.component.html',
  styleUrls: ['./environment-release-package.component.scss'],
  standalone: false
})
export class EnvironmentReleasePackageComponent {
}
